import React from "react";
import Typewriter from "typewriter-effect";
import Fade from "react-reveal/Fade";

import coin from "./graphics/coin.png";

function About() {
  return (
    <div id="about" name="about">
      <div className="about-page">
        <div className="about-inner">
          <Typewriter
            onInit={(typewriter) => {
              typewriter
                .typeString("About()")
                .pauseFor(2000)
                .deleteAll()
                .deleteAll()
                .start();
            }}
            options={{ loop: true, cursor: "_" }}
          />
          <Fade bottom cascade>
            <div className="about-content">
              <div className="about-text">
                <p>
                  Hi! My name is <span className="highlight-green">James</span>,
                  and I&apos;m a software engineer at {" "}
                  <span className="highlight-stripe">Stripe</span>.
                </p>
                <p style={{ marginTop: "30px" }}>{`self().facts = {`}</p>
                <div className="about-facts">
                  <p>
                    <img src={coin} alt="" />
                    {` current_location = New York, NY 🗽`}
                  </p>
                  <p>
                    <img src={coin} alt="" />
                    {` college = Duke University 🎓`}
                  </p>
                  <p>
                    <img src={coin} alt="" />
                    {` hometown = Singapore 🇸🇬`}
                  </p>
                  <p>
                    <img src={coin} alt="" />
                    {` interests = [traveling ✈️, karaoke 🎤, theater 🎭]`}
                  </p>
                </div>
                <p>{`}`}</p>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
}

export default About;
